import styled from "styled-components";

export const Preview = styled("div")`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const Title = styled("h3")`
  margin: 0px 0px 22px;
  font-weight: 600;
  font-size: 24px;
  line-height: 29px;
  color: #2d3436;
`;

export const Text = styled("p")`
  font-size: 16px;
  line-height: 19px;
  color: #2d3436;
  margin: 0px 0px 16px;
`;

export const Total = styled("div")`
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 16px;
  font-weight: 600;
`;

export const Email = styled("div")`
  font-size: 16px;
  line-height: 32px;
  display: flex;
  gap: 12px;
`;

export const LetterGroup = styled("div")`
  margin-bottom: 12px;
`;

export const Letter = styled("div")`
  font-size: 16px;
  line-height: 32px;
`;

export const Delete = styled("button")`
  border: 0px;
  margin: 0px;
  padding: 0px;
  background-color: transparent;
  cursor: pointer;
`;

export const VerticalScroll = styled("div")`
  overflow: auto;
  height: calc(100vh - 418px);
  min-height: 190px;
`;
